<template>
  <div :class="['c-toasts__item', 'c-toasts__item--' + toast.type]" ><svg v-if="typeIcon" :class="['icon', typeIcon]"><use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#' + typeIcon"></use></svg><span class="c-toasts__item-text">{{ toast.text }}</span></div>
</template>

<script>
  export default {
    props: {
      toast: {
        type: Object,
        required: true
      }
    },

    computed: {
      typeIcon () {
        switch (this.toast.type) {
          case 'success': 
            return 'icon-confirm';
          break;

          case 'danger': 
            return 'icon-cancel';
          break;

          case 'warning': 
            return 'icon-notifications';
          break;

          default: 
            return null;
          break;
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/shared/components/Toast.vue